import React from 'react'
import { pastDueOf, currencyFormat0 } from './arAgingModel'

const ESCALATE_REASONS = [
  'No response after repeated attempts',
  'Disputed balance',
  'Broken promise to pay',
  'Needs legal review'
]

const PTP_HORIZONS = [
  { value: '3', label: 'In 3 days' },
  { value: '7', label: 'In 1 week' },
  { value: '14', label: 'In 2 weeks' },
  { value: '30', label: 'In 30 days' }
]

const CONFIG = {
  escalate: { eyebrow: 'ESCALATE COLLECTION', tone: 'warn', confirm: 'Escalate' },
  pause: { eyebrow: 'PAUSE SERVICES', tone: 'danger', confirm: 'Pause services' },
  ptp: { eyebrow: 'LOG PROMISE TO PAY', tone: 'info', confirm: 'Log promise' }
}

// Centered modal shared by escalate / pause / promise-to-pay. The container owns
// submission; this component collects the form and calls onConfirm(payload).
const ArCollectionsDialog = ({ type, company, busy, error, onCancel, onConfirm }) => {
  const config = CONFIG[type]
  const [reason, setReason] = React.useState(ESCALATE_REASONS[0])
  const [note, setNote] = React.useState('')
  const [amount, setAmount] = React.useState('')
  const [horizon, setHorizon] = React.useState('7')

  if (!company || !config) return null
  const pastDue = pastDueOf(company.buckets)

  const submit = () => {
    if (type === 'escalate') return onConfirm({ reason, note })
    if (type === 'pause') return onConfirm({ note })
    return onConfirm({ amount: Number(amount) || pastDue, inDays: Number(horizon) })
  }

  return (
    <div className="ar-dialog-scrim" onClick={onCancel}>
      <div className="ar-dialog" onClick={event => event.stopPropagation()}>
        <div className={`ar-dialog-eyebrow tone-${config.tone}`}>{config.eyebrow}</div>
        <h3 className="ar-dialog-title">{company.companyName}</h3>

        {type === 'escalate' && (
          <>
            <p className="ar-dialog-body">Pulls this account out of the automated run and assigns it to a person. No further automated messages will send.</p>
            <div className="ar-radio-list">
              {ESCALATE_REASONS.map(option => (
                <button
                  key={option}
                  type="button"
                  className={`ar-radio ${reason === option ? 'active' : ''}`}
                  onClick={() => setReason(option)}
                >
                  <span className="ar-radio-dot" />{option}
                </button>
              ))}
            </div>
            <textarea className="ar-dialog-input" rows={3} placeholder="Note (optional)" value={note} onChange={event => setNote(event.target.value)} />
          </>
        )}

        {type === 'pause' && (
          <>
            <p className="ar-dialog-body">Crews will be held from all {company.properties?.length || 0} propert{(company.properties?.length || 0) === 1 ? 'y' : 'ies'} starting with the next scheduled visit. Aspire work tickets go on hold.</p>
            <textarea className="ar-dialog-input" rows={3} placeholder="Note (optional)" value={note} onChange={event => setNote(event.target.value)} />
          </>
        )}

        {type === 'ptp' && (
          <>
            <p className="ar-dialog-body">Record a customer commitment so the run holds and the account is tracked to the promised date.</p>
            <input
              className="ar-dialog-input"
              type="number"
              min="0"
              placeholder={`Amount — default ${currencyFormat0(pastDue)}`}
              value={amount}
              onChange={event => setAmount(event.target.value)}
            />
            <select className="ar-dialog-input" value={horizon} onChange={event => setHorizon(event.target.value)}>
              {PTP_HORIZONS.map(option => <option key={option.value} value={option.value}>{option.label}</option>)}
            </select>
          </>
        )}

        {error && <div className="ar-dialog-error">{error}</div>}

        <div className="ar-dialog-actions">
          <button type="button" className="ar-btn ar-btn-outline" disabled={busy} onClick={onCancel}>Cancel</button>
          <button
            type="button"
            className={`ar-btn ar-btn-confirm tone-${config.tone}`}
            disabled={busy}
            onClick={submit}
          >{busy ? 'Saving…' : config.confirm}</button>
        </div>
      </div>
    </div>
  )
}

export default ArCollectionsDialog
